import { path } from 'ramda'
import { useSelector } from 'react-redux'

import { RootState } from '@/lib/redux'

import { PublicSession } from './types'

export const usePublicSession = (): PublicSession => {
  const value = useSelector<RootState, unknown>(path(['session', 'public']))
  if (value && typeof value === 'object') return value as PublicSession
  return {}
}
